export class CardRequest {
    holder_name: string
    card_number:string
    cvv2:string
    expiration_month:string
    expiration_year:string
}